import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

//Layout
import MainLayout from "Layouts/Main";

// styles
import "./styles.scss";

//assets
import assets from "../../../../Assets";

//redux
import { useDispatch } from "react-redux";
import { fetchIndividualMaintenanceReq } from "../../../../Redux/Slices/requestManagementSlice";


const MaintenanceAssessmentDetails = () => {
  const {id} = useParams()
  let navigate = useNavigate();
  let dispatch = useDispatch();  
  const [maRequestData,setMARequestData] = useState({})

    useEffect(()=>{
      dispatch(fetchIndividualMaintenanceReq({
        data:{id},
        callBack:(value)=>{
          console.log(value.data)
          setMARequestData(value.data)
        }
      }))
     },[]) 

  return (
    <MainLayout pageName="Requests">
      <div className="goBackDiv" onClick={() => navigate(-1)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to Requests</p>
      </div>
      <div className="MaintenanceAssessmentDetailsContainer">
        {/* Header */}
        <div className="MaintenanceAssessmentDetailsHeader">
          <h2>Maintenance Assessment Request Details</h2>
        </div>
        <hr style={{ backgroundColor: "#E6E6E6" }} />
        <div className="MaintenanceAssessmentDetails">
                <h3>Request Details</h3>
                <div>
                  <p className="MaintenanceAssessmentDetailLabel">User Name</p>
                  <p className="MaintenanceAssessmentDetailLabelData">: {maRequestData?.user_name || '-'}</p>
                </div>
                <div>
                  <p className="MaintenanceAssessmentDetailLabel">Mobile Number</p>
                  <p className="MaintenanceAssessmentDetailLabelData">: {maRequestData?.country_code || '-'}&nbsp;{maRequestData?.mobile_number || '-'}</p>
                </div>
                <div>
                  <p className="MaintenanceAssessmentDetailLabel">Email ID</p>
                  <p className="MaintenanceAssessmentDetailLabelData">: {maRequestData?.email || '-'}</p>
                </div>
                <div>
                  <p className="MaintenanceAssessmentDetailLabel">Company</p>
                  <p className="MaintenanceAssessmentDetailLabelData">: {maRequestData?.company_name || '-'}</p>
                </div>
                <div>
                  <p className="MaintenanceAssessmentDetailLabel">Company Type</p>
                  <p className="MaintenanceAssessmentDetailLabelData">: {maRequestData?.company_type || '-'}</p>
                </div>
                {/* <div>
                  <p className="MaintenanceAssessmentDetailLabel">Industry</p>
                  <p className="MaintenanceAssessmentDetailLabelData">: {maRequestData?.company_name || '-'}</p>
                </div> */}
                {/* <div>
                  <p className="MaintenanceAssessmentDetailLabel">Sub Industry</p>
                  <p className="MaintenanceAssessmentDetailLabelData">: {maRequestData?.SubIndustry || '-'}</p>
                </div> */}
                {/* <div>
                  <p className="MaintenanceAssessmentDetailLabel">Message</p>
                  <p className="MaintenanceAssessmentDetailLabelData">: {maRequestData?.additional_details || '-'}</p>
                </div> */}
                <div>
                  <p className="MaintenanceAssessmentDetailLabel">Facility Name</p>
                  <p className="MaintenanceAssessmentDetailLabelData">: {maRequestData?.facility_name || '-'}</p>
                </div>
                <div>
                  <p className="MaintenanceAssessmentDetailLabel">Facility Location</p>
                  <p className="MaintenanceAssessmentDetailLabelData">: {maRequestData?.facility_location || '-'}</p>
                </div>
                <div>
                  <p className="MaintenanceAssessmentDetailLabel">Call Date</p>
                  <p className="MaintenanceAssessmentDetailLabelData">: {maRequestData?.date ? new Date(maRequestData?.date).toLocaleDateString("en-GB") : '-'}</p>
                </div>
                <div>
                  <p className="MaintenanceAssessmentDetailLabel">Selected Session</p>
                  <p className="MaintenanceAssessmentDetailLabelData">: {maRequestData?.session || '-'}</p>
                </div>
                <div>
                  <p className="MaintenanceAssessmentDetailLabel">Selected Slot</p>
                  <p className="MaintenanceAssessmentDetailLabelData">: {maRequestData?.timing || '-'}</p>
                </div>
                <div>
                  <p className="MaintenanceAssessmentDetailLabel">Additional Details</p>
                  <p className="MaintenanceAssessmentDetailLabelData">: {maRequestData?.additional_details || '-'}</p>
                </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default MaintenanceAssessmentDetails;
